<template>
    <div>
        <m-assembly-table ref='pageForm'
                        needScrollBar
                        needSticky
                        columnDrag
                        thDrag
                        :formData='formData'
                        :columns='columns'
                        :data='tableData'
                        :tableButtons='tableButtons'
                        :loading='loading'
                        :currentPage='settings.currentPage'
                        :pageSize='settings.pageSize'
                        :total='settings.total'
                        :settings='settings'
                        :height="600"
                        @onSubmit='onSubmit'
                        @onPageSizeChange='onPageSizeChange'
                        @onCurrentPageChange='onPageChange'
                        @onSelectionChange="onSelectionChange"
        >
        <div slot="button" style="border:1px solid #CCC;border-bottom:none;padding:10px;">
            <Button class="mr10" type="primary" size="small" :disabled="selection.length === 0" :loading="loading" @click="createOrderByNotify">{{$t('createDeliveryOrderToInformView.t56')}}</Button>
            <Button class="mr10" size="small" type="primary" :loading="loading" @click="exportExcel">{{$t('createDeliveryOrderToInformView.t53')}}</Button>
            <set-table class="mr10" :columns="columns.columns" buttonSize="small" @setTableUpdate="setTableUpdate"></set-table>
            <Checkbox class="mr10" v-model="isSameWip" size="small" true-value="Y" false-value="N">{{$t('createDeliveryOrderToInformView.t51')}}</Checkbox>
            <Checkbox v-model="isMergeItemCode" size="small" true-value="Y" false-value="N">{{$t('createDeliveryOrderToInformView.t62')}}</Checkbox>
            <span>{{ $t('createDeliveryOrderToInformView.t52') }}：{{ deliveryTotal }}</span>
        </div>
        </m-assembly-table>

        <!--子库----------------------------------------------------- -->
        <Modal
            v-model="sublibrarySetting.show"
            :width="sublibrarySetting.modalWidth"
            :title="sublibrarySetting.modalTitle"
        >
            <Collapse value="1">
                <Panel name="1">&nbsp;&nbsp;<b>{{$t('page.assemblyTable.searchCondition')}}</b>&nbsp;<Icon
                    type="search"></Icon>
                    <div slot="content">
                        <Form :model="sublibrarySetting" label-position="right" class="bill-form"
                              ref="sublibrarySetting"
                              :rules="sublibrarySetting.rules">
                            <Row :gutter="0">
                                <Col span="8" offset="1">
                                    <FormItem label="" prop="inputValue">
                                        <Input v-model="sublibrarySetting.inputValue" placeholder="" clearable></Input>
                                    </FormItem>
                                </Col>
                                <Col span="7" offset="2">
                                    <FormItem>
                                        <Button type="primary" style="" @click="beforeGetDelLocation2">{{this.$t('common.searchBtn')}}</Button>
                                        <Button type="primary" style="margin-left: 10px" @click="handleSelect2"
                                                :disabled="Object.keys(sublibrarySetting.selectedRow).length === 0 ? true : false">
                                            {{this.$t('createDeliveryOrderToInformView.t47')}}
                                        </Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Panel>
            </Collapse>
            <Table :columns="sublibrarySetting.modalTableColumns"
                   :data="sublibrarySetting.modalTableData"
                   border :loading="sublibrarySetting.loading"
                   stripe highlight-row disabled-hover
                   thDrag
            ></Table>
            <div slot="footer">
                <Page :total="sublibrarySetting.modalTotalpages" :page-size="sublibrarySetting.modalPageSize"
                      :current="sublibrarySetting.modalCurrentPage"
                      @on-change="onModalPageChange2"
                      border show-total show-elevator></Page>
            </div>
        </Modal>
        <!--子库----------------------------------------------------- -->

        <!--厂区----------------------------------------------------- -->
        <Modal
            v-model="locationSetting.show"
            :width="locationSetting.modalWidth"
            :title="locationSetting.modalTitle"
        >
            <Collapse value="1">
                <Panel name="1">&nbsp;&nbsp;<b>{{$t('page.assemblyTable.searchCondition')}}</b>&nbsp;<Icon
                    type="search"></Icon>
                    <div slot="content">
                        <Form :model="locationSetting" label-position="right" class="bill-form" ref="locationSetting"
                              :rules="locationSetting.rules">
                            <Row :gutter="0">
                                <Col span="8" offset="1">
                                    <FormItem label="" prop="inputValue">
                                        <Input v-model="locationSetting.inputValue" placeholder="" clearable></Input>
                                    </FormItem>
                                </Col>
                                <Col span="7" offset="2">
                                    <FormItem>
                                        <Button type="primary" style="" @click="beforeGetDelLocation1">{{this.$t('common.searchBtn')}}</Button>
                                        <Button type="primary" style="margin-left: 10px" @click="handleSelect1"
                                                :disabled="Object.keys(locationSetting.selectedRow).length === 0 ? true : false">
                                            {{this.$t('createDeliveryOrderToInformView.t47')}}
                                        </Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Panel>
            </Collapse>
            <Table :columns="locationSetting.modalTableColumns"
                   :data="locationSetting.modalTableData"
                   border :loading="locationSetting.loading"
                   stripe highlight-row disabled-hover
                   thDrag
            ></Table>
            <div slot="footer">
                <Page :total="locationSetting.modalTotalpages" :page-size="locationSetting.modalPageSize"
                      :current="locationSetting.modalCurrentPage"
                      @on-change="onModalPageChange1"
                      border show-total show-elevator></Page>
            </div>
        </Modal>
        <!--厂区----------------------------------------------------- -->
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
import { deliveryTotalCount } from '@/utils/tool';
export default {
    name: 'createDeliveryOrderToInformView',
    components: { 
        mAssemblyTable 
    },
    data () {
        return {
            deliveryTotal: 0,
            isMergeItemCode: 'N',
            INT_ORGANIZATION_INCREASED: [],
            isSameWip: 'N',
            formData: {
                row: 4,
                items: [
                    {
                        value: '',
                        field: 'orgCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t44')
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        methods: {
                            change: (val) => {
                                /* 是否按相同物料合并 */
                                this.isMergeItemCode = this.INT_ORGANIZATION_INCREASED.find((item) => item.code === val) ? 'Y' : 'N';
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderToInformView.t1') // 库存组织
                    },
                    {
                        value: moment().format('YYYY-MM-01'),
                        field: 'needByDateStart',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t45')
                            }
                        },
                        layout: {
                            row: 1,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderToInformView.t2'), // 需求日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: moment().add(1, 'M'),
                        field: 'needByDateEnd',
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('createDeliveryOrderToInformView.t45')
                            }
                        },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'wipentityNames',
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderToInformView.t3') // 作业号
                    },
                    {
                        value: '',
                        field: 'notifyNumber',
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        title: this.$t('createDeliveryOrderToInformView.t4') // 通知单号
                    },
                    {
                        value: '',
                        field: 'releasedDateStart',
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('createDeliveryOrderToInformView.t45')
                            }
                        },
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderToInformView.t5'), // 通知下达日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'releasedDateEnd',
                        validators: {
                            required: {
                                required: false,
                                message: this.$t('createDeliveryOrderToInformView.t46')
                            }
                        },
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'wipstatus',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 2
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderToInformView.t6') // 作业状态
                    },
                    {
                        value: '',
                        field: 'sourceTypeCode',
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        methods: {
                            change: () => {
                            }
                        },
                        options: {
                            multiple: false,
                            values: []
                        },
                        type: 'select',
                        title: this.$t('createDeliveryOrderToInformView.t7') // 通知类型
                    },
                    {
                        value: '',
                        field: 'confirmDateStart',
                        layout: {
                            row: 3,
                            span: 8,
                            offset: 0
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderToInformView.t8'), // 通知回复日期
                        placeholder: '',
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'confirmDateEnd',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                }
                            }
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: ''
                    },
                    {
                        value: '',
                        field: 'subInventory',
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 3
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        // icon: 'search',
                        // canClick: true,
                        title: this.$t('createDeliveryOrderToInformView.t9'), // 子库
                        click: () => {
                            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                this.sublibrarySetting.show = true;
                            }
                        }
                    },
                    {
                        value: '',
                        field: 'itemCodeStart',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        style: 'width:100%',
                        type: 'text',
                        title: this.$t('createDeliveryOrderToInformView.t10'), // 物料编码从
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        title: this.$t('createDeliveryOrderToInformView.t11'),
                        field: 'itemCodeEnd',
                        disabled: false,
                        placeholder: '',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        style: 'width:100%',
                        type: 'text'
                    },
                    {
                        value: '',
                        field: 'scheduledStartDateStart',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('createDeliveryOrderToInformView.t20'), // 作业上线时间开始
                        isDouble: true
                    },
                    {
                        hide: true,
                        value: '',
                        title: this.$t('createDeliveryOrderToInformView.t20'),
                        field: 'scheduledStartDateEnd',
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59'
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                    },
                    {
                        value: '',
                        field: 'locationCode',
                        disabled: false,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 4
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text',
                        // icon: 'search',
                        // canClick: true,
                        title: this.$t('createDeliveryOrderToInformView.t13'), // 厂区
                        click: () => {
                            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                                this.locationSetting.show = true;
                            }
                        }
                    }
                ]
            },
            columns: {
                columns: [
                    {
                        type: 'selection',
                        width: 35,
                        align: 'center'
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t9'), // 子库
                        key: 'subInventory',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 90 : 70,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t16'), // 物料编码
                        key: 'itemCode',
                        align: 'center',
                        width: 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t17'), // 物料描述
                        key: 'itemName',
                        width: 220,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t24'), // 本次送货数量
                        key: 'noDeliverNum',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 200 : 100,
                        render: (h, params) => {
                            return h('InputNumber', {
                                props: {
                                    size: 'small',
                                    value: Number(params.row.noDeliverNum)
                                },
                                on: {
                                    'on-change': (val) => {
                                        params.row.noDeliverNum = val;
                                        this.tableData[params.index] = params.row;
                                    },
                                    'on-blur': () => {
                                        if (Number(params.row.noDeliverNum) > (Number(params.row.releasedQuantity) - Number(params.row.haveBillNum))) {
                                            this.$Modal.error({
                                                content: this.$t('createDeliveryOrderByOrder.t37')
                                            });
                                            params.row.noDeliverNum = Number(params.row.releasedQuantity) - Number(params.row.haveBillNum);
                                            this.tableData[params.index] = params.row;
                                        }
                                        this.deliveryTotal = deliveryTotalCount(this.$refs.pageForm.getSelection(), 'noDeliverNum');
                                    }
                                }
                            });
                        },
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t18'), // 作业号
                        key: 'wipentityNames',
                        width: 150,
                        tooltip: true,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t19'), // 产线
                        key: 'planLineDesc',
                        width: 150,
                        tooltip: true,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t20'), // 作业上线时间
                        key: 'scheduledStartDate',
                        align: 'center',
                        width: 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t25'), // 作业状态
                        key: 'meaning',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 70 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t26'), // 要求到货时间
                        key: 'needByDate',
                        align: 'center',
                        width: 125,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t22'), // 要求到货数量
                        key: 'releasedQuantity',
                        align: 'right',
                        width: this.$i18n.locale === 'en-US' ? 100 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t23'), // 已制单数量
                        key: 'haveBillNum',
                        align: 'right',
                        width: this.$i18n.locale === 'en-US' ? 100 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t27'), // 买方
                        key: 'organizationName',
                        align: 'center',
                        width: 50
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t28'), // 厂区
                        key: 'locationCode',
                        align: 'center',
                        width: 90,
                        tooltip: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t29'), // 车间
                        key: 'departmentCode',
                        align: 'center',
                        width: 70
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t30'), // 仓管员
                        key: 'warehouseWorkers',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 140 : 110,
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t31'), // 通知类型
                        key: 'sourceTypeMeaning',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 140 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t32'), // 通知单号
                        key: 'notifyNumber',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 160 : 120,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t33'), // 通知下达时间
                        key: 'releasedDate',
                        align: 'center',
                        width: 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t34'), // 通知回复时间
                        key: 'confirmdate',
                        align: 'center',
                        width: 140,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t35'), // 项目号
                        key: 'projectNumber',
                        align: 'center',
                        width: 110,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t36'), // 生产批次
                        key: 'productBatch',
                        align: 'center',
                        width: 130,
                        render: (h, params) => {
                            return h('Input', {
                                props: {
                                    size: 'small',
                                    value: params.row.productBatch
                                },
                                on: {
                                    'on-change': (event) => {
                                        params.row.productBatch = event.target.value;
                                        this.tableData[params.index] = params.row;
                                    }
                                }
                            });
                        },
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t37'), // 订单号
                        key: 'poNumber',
                        width: 120,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t38'), // 订单行号
                        key: 'poLineNumber',
                        align: 'center',
                        width: this.$i18n.locale === 'en-US' ? 110 : 60,
                        sortable: true
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t39'), // 说明
                        key: 'comments',
                        width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t3'), // 采购订单号
                        key: 'erpPoNumber',
                        width: 110
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t47'), // MCO变更标识
                        key: 'plmMcoChangeCode',
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: this.$t('deliveryNoticeConfirm.t48'), // MCO变更说明
                        key: 'plmMcoChangeRemark',
                        width: 100,
                        align: 'center',
                    },
                ]
            },
            tableData: [],
            tableButtons: {},
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 100,
                total: null,
                submitLoading: false
            },
            selection: [],
            sublibrarySetting: {
                show: false,
                modalWidth: 600,
                modalTitle: this.$t('queryStoreToolTable.selectSubStorage'),
                modalTableColumns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t47'),
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.hasSelected
                                },
                                on: {
                                    'on-change': (selection) => {
                                        params.row.hasSelected = selection;
                                        this.sublibrarySetting.modalTableData[params.index] = params.row;
                                        if (selection) {
                                            this.sublibrarySetting.selectedRow = params.row;
                                            for (let i = 0; i < this.sublibrarySetting.modalTableData.length; i++) {
                                                if (i !== params.index) {
                                                    this.sublibrarySetting.modalTableData[i].hasSelected = false;
                                                }
                                            }
                                        } else {
                                            this.sublibrarySetting.selectedRow = {};
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t48'),
                        type: 'index',
                        align: 'center',
                        width: 35
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t16'),
                        key: 'secondaryInventoryName',
                        align: 'center'
                        // width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t29'),
                        key: 'description',
                        align: 'center'
                        // width: 110
                    }
                ],
                modalTableData: [],
                modalTotalpages: 0,
                modalPageSize: 8,
                modalCurrentPage: 1,
                loading: false,
                searchValue: '',  //  搜索的下拉框的值
                searchList: [   //  搜索的下拉框
                    {value: 'invName', label: this.$t('DeliveryOrderQuery.t16')}
                ],
                inputValue: '', //  搜索框的输入值
                selectedRow: {},    //  已勾选的行
                rules: {    //  表单验证
                }
            },
           locationSetting: {
                show: false,
                modalWidth: 600,
                modalTitle: this.$t('queryStoreToolTable.selectFactoryAddress'),
                modalTableColumns: [
                    {
                        title: this.$t('createDeliveryOrderToInformView.t47'),
                        width: 35,
                        align: 'center',
                        render: (h, params) => {
                            return h('Checkbox', {
                                props: {
                                    value: params.row.hasSelected
                                },
                                on: {
                                    'on-change': (selection) => {
                                        params.row.hasSelected = selection;
                                        this.locationSetting.modalTableData[params.index] = params.row;
                                        if (selection) {
                                            this.locationSetting.selectedRow = params.row;
                                            for (let i = 0; i < this.locationSetting.modalTableData.length; i++) {
                                                if (i !== params.index) {
                                                    this.locationSetting.modalTableData[i].hasSelected = false;
                                                }
                                            }
                                        } else {
                                            this.locationSetting.selectedRow = {};
                                        }
                                    }
                                }
                            });
                        }
                    },
                    {
                        title: this.$t('createDeliveryOrderToInformView.t48'),
                        type: 'index',
                        align: 'center',
                        width: 110
                    },
                    {
                        title: this.$t('DeliveryOrderQuery.t15'),
                        key: 'locationCode',
                        align: 'center'
                        // width: 110
                    },
                    {
                        title: this.$t('createDeliveryOrderByOrder.t29'),
                        key: 'description',
                        align: 'center'
                        // width: 110
                    }
                ],
                modalTableData: [],
                modalTotalpages: 0,
                modalPageSize: 8,
                modalCurrentPage: 1,
                loading: false,
                searchValue: '',  //  搜索的下拉框的值
                searchList: [   //  搜索的下拉框
                    {value: 'locationCode', label: this.$t('DeliveryOrderQuery.t15')}
                ],
                inputValue: '', //  搜索框的输入值
                selectedRow: {},    //  已勾选的行
                rules: {    //  表单验证
                    // inputValue: [{required: true, trigger: 'change', message: this.$t('createDeliveryOrderToInformView.t49')}]
                }
            }
        }
    },
    methods: {
        onSubmit (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange (currentPage, pageSize) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange (currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSelectionChange (selection) {
            this.selection = selection;
            this.deliveryTotal = deliveryTotalCount(this.$refs.pageForm.getSelection(), 'noDeliverNum');
        },
        onSearch () {
            this.loading = true;
            axios.post('/gscint/order/queryCanCreateOrderNotify', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.$i18n.locale
            })
            .then((res) => {
                this.loading = false;
                let data = res.data.data;
                if (data.code === '1') {
                    this.tableData = data.datas.list;
                    this.settings.total = data.datas.total;
                    this.selection = [];
                    this.deliveryTotal = deliveryTotalCount([], 'noDeliverNum');
                }
            })
            .catch(() => {
                this.showErrorTips();
            });
        },
        beforeGetDelLocation2 () {
            this.$refs['sublibrarySetting'].validate((valid) => {
                if (valid) {
                    this.getDelSubInv();
                }
            });
        },
        /** 获取送货子库 */
        getDelSubInv () {
            this.sublibrarySetting.loading = true;
            axios.post('/gscint/order/querySubinventory', {
                organizationCode: this.getFormDataItemVal(this.formData.items, 'orgCode'),
                locationCode: this.sublibrarySetting.searchValue,
                pageIndex: this.sublibrarySetting.modalCurrentPage,
                pageSize: this.sublibrarySetting.modalPageSize
            })
            .then((res) => {
                this.sublibrarySetting.loading = false;
                let data = res.data.data.datas;
                if (data.list) {
                    this.sublibrarySetting.modalTotalpages = data.total;
                    data.list.map((item) => {
                        item.hasSelected = false;
                        return item;
                    });
                    this.sublibrarySetting.modalTableData = data.list;
                }
            })
            .catch(() => {
                this.sublibrarySetting.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        // 选择子库
        handleSelect2 () {
            this.sublibrarySetting.show = false;
            this.getFormDataItemObj(this.formData.items, 'subInventory').value = this.sublibrarySetting.selectedRow.secondaryInventoryName;
        },
        // 子库分页
        onModalPageChange2 (currentPage) {
            this.sublibrarySetting.modalCurrentPage = currentPage;
            this.sublibrarySetting.selectedRow = {};
            this.getDelSubInv();
        },
        // 厂区
        beforeGetDelLocation1 () {
            this.$refs['locationSetting'].validate((valid) => {
                if (valid) {
                    this.getDelLocation();
                }
            });
        },
        /** 获取送货厂区 */
        getDelLocation () {
            this.locationSetting.loading = true;
            axios.post('/gscint/order/queryLocation', {
                organizationCode: this.getFormDataItemVal(this.formData.items, 'orgCode'),
                locationCode: this.locationSetting.searchValue,
                pageIndex: this.locationSetting.modalCurrentPage,
                pageSize: this.locationSetting.modalPageSize
            })
            .then((res) => {
                this.locationSetting.loading = false;
                let data = res.data.data.datas;
                if (data.list) {
                    this.locationSetting.modalTotalpages = data.total;
                    data.list.map((item) => {
                        item.hasSelected = false;
                        return item;
                    });
                    this.locationSetting.modalTableData = data.list;
                }
            })
            .catch(() => {
                this.locationSetting.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        handleSelect1 () {
            this.locationSetting.show = false;
            this.getFormDataItemObj(this.formData.items, 'locationCode').value = this.locationSetting.selectedRow.LOCATIONCODE;
        },
        onModalPageChange1 (currentPage) {
            this.locationSetting.modalCurrentPage = currentPage;
            this.locationSetting.selectedRow = {};
            this.getDelLocation();
        },
        // 创建送货单
        createOrderByNotify () {
            try {
                this.loading = true;
                let detailList = this.$refs.pageForm.$refs.iTable.$refs.iTable.getSelection();
                axios.post('/gscint/order/createOrderByNotify', {
                    publicParams: {
                        vendorCode: this.vendorCode,
                        orgCode: this.getFormDataItemVal(this.formData.items, 'orgCode'),
                        isSameWip: this.isSameWip,
                        isMergeItemCode: this.isMergeItemCode === 'Y'
                    },
                    detailList
                })
                .then((res) => {
                    this.loading = false;
                    let data = res.data.data;
                    if (data.code === '1') {
                        this.$Modal.success({
                            content: data.msg
                        });
                        this.selection = [];
                        this.deliveryTotal = deliveryTotalCount([], 'noDeliverNum');
                        this.onSearch();
                    } else {
                        this.$Modal.error({
                            content: data.msg
                        });
                    }
                })
                .catch(() => {
                    this.showErrorTips();
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 导出
        exportExcel () {
            if (this.$refs.pageForm.$refs.queryForm.validateForm()) {
                this.loading = true;
                window.open(`/gscint/order/exportCanCreateOrderNotify?paraJson=${encodeURI(JSON.stringify(
                    {
                        ...this.getFormDataVModel(this.formData.items),
                        vendorCode: this.vendorCode
                    }
                ))}`);
                setTimeout(() => {
                    this.loading = false;
                }, 5000);
            }
        },
        setTableUpdate(columns) {
            this.columns.columns = columns;
        },
    },
    mounted () {
        this.getSRMInvLovListNew((data) => {
            let list = [];
            data.forEach((item) => {
                list.push({
                    label: item.organizationName,
                    value: item.organizationCode
                });
            });
            this.getFormDataItemObj(this.formData.items, 'orgCode').options.values = list; 
        });
        this.getDict('INT_MAKEORDERSTATUS', (data) => {
            this.getFormDataItemObj(this.formData.items, 'wipstatus').options.values = data;
        });
        this.getDict('INT_PM_FD_FEED_TYPES', (data) => {
            this.getFormDataItemObj(this.formData.items, 'sourceTypeCode').options.values = data;
        });
        /* 判断合并是否区分物料编码 */
        this.getDict('INT_ORGANIZATION_INCREASED');
    }
}
</script>
<style lang="less" scoped>
.mr10 {
    margin-right: 10px;
}
</style>